<template>
    <div class="router-summary">
        <section>
            <div class="controls">
                <button
                    class="_approve"
                    @click="$emit('update-band-details')"
                >
                    Update
                </button>
            </div>
            
            <header>
                <h3>Router and band details</h3>
            </header>

            <h4>Router Name</h4>
            <p>{{ formData.name || '--' }}</p>

            <h4>Router MAC address</h4>
            <p>{{ formData.macAddress || '--' }}</p>

            <h4>Router IP address</h4>
            <p>{{ formData.ipAddress || '--' }}</p>

            <h4>Total registered band</h4>
            <p>{{ bandsCount }}</p>
        </section>

        <section>
            <div class="controls">
                <button
                    class="_approve"
                    @click="$emit('update-account-info')"
                >
                    Update
                </button>
            </div>
            
            <header>
                <h3>Router account information</h3>
            </header>

            <h4>Host Account Name</h4>
            <p class="name">{{ formData.client.full_name || '--' }}</p>

            <h4>Host Email</h4>
            <p>{{ formData.client.host_email || '--' }}</p>

            <h4>Host Company Name</h4>
            <p>{{ formData.client.company_name || '--' }}</p>

            <h4>Host Company Email</h4>
            <p>{{ formData.client.email || '--' }}</p>
        </section>
    </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields'
export default {
    computed: {
		...mapFields('router', {
			formData: 'createForm',
		}),

		bandsCount () {
			const { bands } = this.formData
			const macAddressRegEx = /^[a-fA-F0-9]{2}(:[a-fA-F0-9]{2}){5}$/

			return bands.reduce((count, band) => {
				if (macAddressRegEx.test(band.macAddress) &&
					band.name.trim() !== '') {
					count += 1
				}

				return count
			}, 0)
		}
	}
}
</script>

<style lang="scss" scoped>
.router-summary {
    max-width: 600px;
}

.controls {
    display: flex;
    justify-content: flex-end;
    align-items: center;
}

header {
    padding-bottom: 15px;
    margin-bottom: 20px;
    border-bottom: 1px solid #D8DEEB;
}

h4 {
    margin-bottom: 10px;
}

p {
    text-align: left;
    margin-bottom: 25px;
	color: #778395;
	
	&.name {
		text-transform: capitalize;
	}
}
</style>